import type { SVGProps } from 'react';
const DawnFlagVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-VG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-VG_svg__a)">
      <path fill="#07319C" d="M0 0h22v16H0z" />
      <path
        fill="#008339"
        fillRule="evenodd"
        d="M13.62 8V5.6c0-.737.596-1.333 1.333-1.333h2.57c.737 0 1.334.596 1.334 1.332V8c0 2.668-2.619 3.734-2.619 3.734S13.62 10.667 13.62 8"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-VG_svg__b"
        width={6}
        height={8}
        x={13}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M13.62 8V5.6c0-.737.596-1.333 1.333-1.333h2.57c.737 0 1.334.596 1.334 1.332V8c0 2.668-2.619 3.734-2.619 3.734S13.62 10.667 13.62 8"
          clipRule="evenodd"
        />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-VG_svg__b)">
        <path
          fill="#FFD033"
          d="M15.19 6.4c.29 0 .525-.239.525-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m0 1.067c.29 0 .525-.24.525-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534m0 1.066A.53.53 0 0 1 14.668 8c0-.295.235-.533.524-.533s.524.238.524.533a.53.53 0 0 1-.524.533m0 0a.53.53 0 0 0-.523.534c0 .294.235.533.524.533s.524-.239.524-.533a.53.53 0 0 0-.524-.534m2.62.534a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534A.53.53 0 0 1 16.762 8c0-.295.235-.533.524-.533s.524.238.524.533a.53.53 0 0 1-.524.533c.29 0 .524.24.524.534M17.286 6.4a.53.53 0 0 0-.524.533c0 .295.235.534.524.534s.524-.24.524-.534a.53.53 0 0 0-.524-.533m0 0a.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534s.524.239.524.534a.53.53 0 0 1-.524.533"
        />
        <path
          fill="#fff"
          d="M16.239 9.067c.289 0 .523-.717.523-1.6s-.234-1.6-.523-1.6-.524.716-.524 1.6c0 .883.234 1.6.524 1.6"
        />
      </g>
      <path
        fill="#FFD033"
        d="M13.096 10.667c0 1.017 1.43 1.6 3.143 1.6s3.142-.583 3.142-1.6a.53.53 0 0 0-.523-.534.53.53 0 0 0-.524.534c0 .01-.127.132-.438.259-.422.172-1.017.274-1.657.274s-1.236-.102-1.658-.274c-.31-.127-.438-.25-.438-.26a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.534"
      />
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M3.667 3.2 0 0h.524L4.19 2.667h1.048L9.428 0v.364a.33.33 0 0 1-.137.27L5.761 3.2v1.067L9.078 7.16a.175.175 0 0 1-.115.307"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.667 3.2v1.067L0 6.933v.534L4.19 4.8H5.24l3.62 2.633a.175.175 0 0 0 .218-.273L5.762 4.267V3.2L9.292.633a.33.33 0 0 0 .137-.27V0l-4.19 2.667H4.19L.524 0H0zm.74-1.2L.742-.667h-2.518L3 3.503v.424L-.666 6.594V8.68l5.051-3.214h.637l3.445 2.505a.84.84 0 0 0 .495.161c.778 0 1.14-.964.554-1.476L6.429 3.964V3.54l3.255-2.368a1 1 0 0 0 .412-.808v-1.578L5.044 2z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 2.667V4.8h3.667v2.533c0 .369.298.667.666.667h.762a.667.667 0 0 0 .667-.667V4.8h3.524a.667.667 0 0 0 .666-.667v-.8a.667.667 0 0 0-.666-.666H5.762V0H3.667v2.667z"
        clipRule="evenodd"
      />
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M0 3.2h4.19V0h1.048v3.2h4.19v1.067h-4.19v3.2H4.19v-3.2H0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagVG;
